module.exports = __webpack_public_path__ + "img/agent-center-integrated.057affef.png";